import { PrescriptionAndUnHandledOrdersContext } from 'Context';
import { useContext } from 'react';

export const useMedications = () => {
  const { STATUS, medications } = useContext(
    PrescriptionAndUnHandledOrdersContext
  );

  return {
    STATUS,
    medications,
  };
};
